import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import TareaCardImg from "../../components/UmmIApps/Cards/TareaCardImg.png";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import DescripcionClasesPrevias from "../../components/Form/Fields/DescripcionClasesPrevias";
import DescripcionTareaTarea from "../../components/Form/Fields/DescripcionTareaTarea";
import TemaTarea from "../../components/Form/Fields/TemaTarea";
import TiempoDedicacionTarea from "../../components/Form/Fields/TiempoDedicacionTarea";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../config/sendButtonRules";


const TareaPage = () => {

  const {
    nivelId,
    materiaId,
    handleBack,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    setTextoInicial,
    handleInitialPromptData,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    setPromptData,
    nivelTPId,
    asignaturaTPId,
  } = useActividadesContext();


  //Variable para condicionar la habilitación del botón "Generar"
 const isButtonDisabled =  isSendButtonDisabled("tareas_hogar", { promptData });
  const colorIconBack = "#BA4534";

  useEffect(() => {
    const init = {
      tema: "",
      tiempo: 10,
      descripcion_clases_previas: "",
      adaptaciones_curriculares: "",
      descripcion_tarea: "",
      condiciones_contexto: "",
      caracterizacion: "",
    };
    handleInitialPromptData(init, "tareas_hogar");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti.  Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={TareaCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)"
        }
        titleColor="#BA4534"
        title="Tarea"
        description="Diseña actividades innovadoras y detalladas que desafíen a los estudiantes a practicar y aplicar sus conocimientos de manera creativa y significativa."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
           
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
         
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 3 }}>
          <TemaTarea />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          <TiempoDedicacionTarea />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandLessIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12}>
              <DescripcionClasesPrevias />
            </Grid>
            <Grid item xs={12}>
              <DescripcionTareaTarea />
            </Grid>
            <Grid item xs={12}>
              <CondicionesContexto />
            </Grid>
            <Grid item xs={12}>
              <Caracterizacion />
            </Grid>
            <Grid item xs={12}>
              <AdaptacionesCurriculares />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default TareaPage;
